// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  firebase: {
    apiKey: "AIzaSyDSlLSxMmYFHdF9lUWI_SHfwnQHCfMX5OQ",
    authDomain: "zenithbattle.firebaseapp.com",
    databaseURL: "https://zenithbattle.firebaseio.com",
    projectId: "zenithbattle",
    storageBucket: "zenithbattle.appspot.com",
    messagingSenderId: "557730335996"
  }
};



// WEBPACK FOOTER //
// d:/xampp/htdocs/zenith-admin/src/environments/environment.ts